export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8284.335bd622.jpg";